export const formBuilderEndpoints = {
  forms: "/form-builder/forms",
  formVersions: (formId: string) => `/form-builder/forms/${encodeURIComponent(formId)}/versions`,
  formVersion: (formId: string, version: number) =>
    `/form-builder/forms/${encodeURIComponent(formId)}/versions/${version}`,
  visits: "/form-builder/visits",
  workOrders: "/form-builder/work-orders",
  assistant: "/form-builder/assistant",
  assignmentsAssistant: "/form-builder/assistant/assignments",
} as const;
